var map = {
	"./ERP_tihuo.svg": "6041",
	"./address.svg": "0e25",
	"./balance.svg": "b186",
	"./chaxun_wei.svg": "a127",
	"./chaxun_yi.svg": "a676",
	"./cxc-logo.svg": "9a80",
	"./cxc_logo.svg": "2992",
	"./dangqian.svg": "6bb5",
	"./daochu_b.svg": "1124",
	"./daoru_b.svg": "a852",
	"./dashboard.svg": "f782",
	"./dayin.svg": "df28",
	"./dayin_b.svg": "e77b",
	"./delete.svg": "59a1",
	"./dizhi_wei.svg": "8bc6",
	"./dizhi_yi.svg": "b7cd",
	"./edit.svg": "aa46",
	"./example.svg": "30c3",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./form.svg": "eb1b",
	"./gouxuan.svg": "eeb3",
	"./guanli_wei.svg": "938f",
	"./guanli_yi.svg": "a261",
	"./international.svg": "17df",
	"./kefun.svg": "04d0",
	"./language.svg": "2580",
	"./link.svg": "18f0",
	"./list_logo.svg": "d696",
	"./logo-menu.svg": "b476",
	"./nested.svg": "dcf8",
	"./password.svg": "2a3d",
	"./phone.svg": "dd82",
	"./piliang.svg": "51c3",
	"./qingkong_b.svg": "a2b8",
	"./quanxuan.svg": "9f16",
	"./receipt.svg": "2824",
	"./routing.svg": "6989",
	"./send.svg": "94d0",
	"./shanchu_b.svg": "ad7f",
	"./shop.svg": "5def",
	"./shou_hui.svg": "cb86",
	"./shoujian_wei.svg": "8c5f",
	"./shoujian_yi.svg": "6573",
	"./shuaixin_b.svg": "0625",
	"./sousuo.svg": "ceb2",
	"./sousuo_b.svg": "8df6",
	"./suoshou.svg": "8643",
	"./susess1.svg": "4186",
	"./system.svg": "30a9",
	"./table.svg": "47f1",
	"./tip.svg": "f943",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5",
	"./warehouseOut.svg": "e154",
	"./waybill.svg": "9240",
	"./whatapp.svg": "56ce",
	"./xiafa_b.svg": "7947",
	"./xiafa_l.svg": "4e8a",
	"./xinjian_b.svg": "0aa3",
	"./xinjian_l.svg": "0faa",
	"./xuanzhong.svg": "1cef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";